import { ContainerModule } from 'inversify';

import { CsvGeneratorService } from '@shared/common/file/domain/service/csv-generator.service';
import { ZipGeneratorService } from '@shared/common/file/domain/service/zip-generator.service';
import { FileDependencyTypes } from '@shared/common/file/file.dependency-types';

export const fileContainerModule = new ContainerModule(({ bind }) => {
  bind<CsvGeneratorService>(FileDependencyTypes.CsvGeneratorService).to(CsvGeneratorService);
  bind<ZipGeneratorService>(FileDependencyTypes.ZipGeneratorService).to(ZipGeneratorService);
});
